const COMMON_SET_HIGH_CONTRAST_MODE = 'COMMON_SET_HIGH_CONTRAST_MODE';
const COMMON_SET_USER_IS_A_MEMBER = 'COMMON_SET_USER_IS_A_MEMBER';

export const commonState = {
	highContrastMode: false,
	userIsAMember: false
};

export const commonActions = {
	setHighContrastMode({commit}, value) {
		commit(COMMON_SET_HIGH_CONTRAST_MODE, value);
	},
	setUserIsAMember({commit}, value) {
		commit(COMMON_SET_USER_IS_A_MEMBER, value);
	}
};

export const commonMutations = {
	[COMMON_SET_HIGH_CONTRAST_MODE](state, highContrastMode) {
		state.highContrastMode = highContrastMode;
	},
	[COMMON_SET_USER_IS_A_MEMBER](state, userIsAMember) {
		state.userIsAMember = userIsAMember;
	}
};
